<section class="home-testimonios" aria-labelledby="home-testimonios-title">
  <div class="home-testimonios__inner">
    <div class="home-testimonios__heading">
      <p class="home-testimonios__eyebrow">{{ eyebrow }}</p>
      <h2 id="home-testimonios-title" class="home-testimonios__title">
        {{ titleLead }}
        <span class="home-testimonios__title-accent" *ngIf="titleAccent">{{
          titleAccent
        }}</span>
      </h2>
    </div>

    <div
      class="home-testimonios__carousel"
      aria-label="Testimonios de emprendedores"
      (mouseenter)="pauseAutoplay()"
      (mouseleave)="resumeAutoplay()"
      (focusin)="pauseAutoplay()"
      (focusout)="resumeAutoplay()"
      *ngIf="testimonials.length"
    >
      <div class="home-testimonios__bubble" aria-hidden="true"></div>

      <div class="home-testimonios__track">
        <article
          *ngFor="let item of testimonials; let i = index"
          class="home-testimonios__card"
          [ngClass]="
            'home-testimonios__card--' +
            getCardState(i) +
            (isPlaying(i) ? ' home-testimonios__card--playing' : '')
          "
          [attr.aria-hidden]="getCardState(i) === 'hidden' ? 'true' : null"
          [attr.tabindex]="getCardState(i) === 'hidden' ? -1 : 0"
          role="button"
          [attr.aria-label]="'Ver testimonio de ' + item.name"
          (click)="goToTestimonial(i)"
          (keydown.enter)="goToTestimonial(i)"
          (keydown.space)="goToTestimonial(i); $event.preventDefault()"
        >
          <div class="home-testimonios__video">
            <!-- Preview: thumbnail + overlays (estado Figma) -->
            <ng-container *ngIf="!isPlaying(i)">
              <img
                *ngIf="item.tipoBanner !== 'VideoEncuesta'"
                class="home-testimonios__image"
                [src]="displayThumbnail(item)"
                [alt]="item.imageAlt"
              />
              <video
                *ngIf="item.tipoBanner === 'VideoEncuesta' && item.mediaUrl"
                class="home-testimonios__image"
                [src]="safeMediaUrl(item.mediaUrl)"
                muted
                playsinline
                preload="metadata"
                [attr.aria-label]="item.imageAlt"
              ></video>
              <span class="home-testimonios__overlay" aria-hidden="true"></span>
              <button
                *ngIf="getCardState(i) === 'active' && canPlay(item)"
                type="button"
                class="home-testimonios__play-btn"
                [attr.aria-label]="'Reproducir testimonio de ' + item.name"
                (click)="playTestimonial(i, $event)"
              >
                <img
                  class="home-testimonios__play"
                  src="assets/img/Home/testimonios/icon-play.svg"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <p
                class="home-testimonios__quote"
                *ngIf="getCardState(i) === 'active'"
              >
                {{ item.quote }}
              </p>
            </ng-container>

            <!-- Reproducción: embed YouTube o video encuesta -->
            <ng-container *ngIf="isPlaying(i) && youtubeConsent">
              <iframe
                *ngIf="item.tipoBanner === 'Video' && item.embedUrl"
                class="home-testimonios__embed"
                [src]="safeMediaUrl(embedUrlWithAutoplay(item.embedUrl))"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <video
                *ngIf="item.tipoBanner === 'VideoEncuesta' && item.mediaUrl"
                class="home-testimonios__embed"
                [src]="safeMediaUrl(item.mediaUrl)"
                controls
                autoplay
                (ended)="onMediaEnded()"
                title="Reproducir video"
              >
                Su navegador no soporta la etiqueta de vídeo.
              </video>
            </ng-container>
          </div>

          <div class="home-testimonios__meta">
            <p class="home-testimonios__name">{{ item.name }}</p>
            <p class="home-testimonios__role">{{ item.role }}</p>
          </div>
        </article>
      </div>

      <div
        class="home-testimonios__mobile-actions"
        aria-label="Controles de testimonios"
      >
        <div class="home-testimonios__dots">
          <button
            *ngFor="let item of testimonials; let i = index"
            type="button"
            class="home-testimonios__dot"
            [ngClass]="{ 'home-testimonios__dot--active': i === currentIndex }"
            [attr.aria-label]="'Ir a testimonio ' + (i + 1)"
            [attr.aria-current]="i === currentIndex ? 'true' : null"
            (click)="goToTestimonial(i)"
          ></button>
        </div>

        <div class="home-testimonios__arrows">
          <button
            type="button"
            class="home-testimonios__arrow"
            aria-label="Testimonio anterior"
            (click)="prevTestimonial()"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M15 6L9 12L15 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            type="button"
            class="home-testimonios__arrow"
            aria-label="Siguiente testimonio"
            (click)="nextTestimonial()"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M9 6L15 12L9 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
